// extracted by mini-css-extract-plugin
export default {"combined-button":"combined-button_combined-button__GKvdb","action":"combined-button_action__g-DWi","active":"combined-button_active__+1TGd"};